import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import RCPagination from '../UserControl/Pagination/RCPagination';
import {AlertBar, AlertCommit, AlertConfirm, Alert} from '../../Modals/AlertBar';
import { withNamespaces } from 'react-i18next';
import ModalConfirmDelete from '../../Modals/ModalConfirmDelete';

class MaintenanceSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maintenanceSummaryList: [],
            deviceNoList: [],
            selectedDevice: '',
            currentPage: 1,
            currentPageSize: 10,
            totalPage: 0,
            isGroupOrder: true,
            searchStr: ''
        }
    }

    componentDidMount() {
        this.getMaintenanceAlertList('', true);
        this.getActiveDeviceUserRelated();
    }

    onPageSelect(page, isSort){
        const { currentPageSize, searchStr } = this.state;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getMaintenanceAlertList/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter": searchStr,
                "isGroupOrder" : isSort
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        alertRepeat: obj.alert_repeat,
                        counter: obj.counter,
                        deviceId: obj.device_id,
                        deviceNo: obj.device_no,
                        deviceGroup: obj.device_group,
                        isEmailSent: obj.is_email_alert,
                        isAlert: obj.is_alert,
                        isEmailAlert: obj.is_email_alert,
                        isLineAlert: obj.is_line_alert,
                        lastAlertDtm: obj.last_alert_dtm,
                        lineSent: obj.line_sent,
                        maListId: obj.ma_list_id,
                        maName: obj.ma_name,
                        measureType: obj.measure_type,
                        measureTypeId: obj.measure_type_id,
                        measureUnit: obj.measure_unit,
                        nextAlertWhen: obj.next_alert_when,
                        remark: obj.remark
                    });
                    this.setState({
                        currentPage: page,
                        totalPage: data.RESULT_TOTAL,
                        currentPageSize: currentPageSize
                    })
                });
                this.setMaintenanceList(objList);

            })
            // .then(() => this.onChangeSortData(page))
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSizeChange(page, pageSize){
        const { isGroupOrder, currentPageSize, searchStr } = this.state;
        const { user_id, user_name, token } = this.props;
        // let searchText = searchStr || '';
        fetch(`http://203.150.199.244/api/admin/getMaintenanceAlertList/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter": searchStr,
                "isGroupOrder" : isGroupOrder
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        alertRepeat: obj.alert_repeat,
                        counter: obj.counter,
                        deviceId: obj.device_id,
                        deviceNo: obj.device_no,
                        deviceGroup: obj.device_group,
                        isEmailSent: obj.is_email_alert,
                        isAlert: obj.is_alert,
                        isEmailAlert: obj.is_email_alert,
                        isLineAlert: obj.is_line_alert,
                        lastAlertDtm: obj.last_alert_dtm,
                        lineSent: obj.line_sent,
                        maListId: obj.ma_list_id,
                        maName: obj.ma_name,
                        measureType: obj.measure_type,
                        measureTypeId: obj.measure_type_id,
                        measureUnit: obj.measure_unit,
                        nextAlertWhen: obj.next_alert_when,
                        remark: obj.remark
                    });
                    this.setState({
                        currentPage: page,
                        totalPage: data.RESULT_TOTAL,
                        // currentPageSize: currentPageSize
                        currentPageSize: pageSize
                    })
                });
                this.setMaintenanceList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getMaintenanceAlertList = (searchStr, isSort) => {
        const { user_id, user_name, token } = this.props;
        const { isGroupOrder, currentPageSize } = this.state;
        // console.log('isGroupOrder:', isGroupOrder);
        // console.log('searchStr:', searchStr);
        let searchText = searchStr || '';
        fetch(`http://203.150.199.244/api/admin/getMaintenanceAlertList/1/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter": searchText,
                "isGroupOrder" : isSort
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                // console.log('data5555:', data );
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        alertRepeat: obj.alert_repeat,
                        counter: obj.counter,
                        deviceId: obj.device_id,
                        deviceNo: obj.device_no,
                        deviceGroup: obj.device_group,
                        isEmailSent: obj.is_email_alert,
                        isAlert: obj.is_alert,
                        isEmailAlert: obj.is_email_alert,
                        isLineAlert: obj.is_line_alert,
                        lastAlertDtm: obj.last_alert_dtm,
                        lineSent: obj.line_sent,
                        maListId: obj.ma_list_id,
                        maName: obj.ma_name,
                        measureType: obj.measure_type,
                        measureTypeId: obj.measure_type_id,
                        measureUnit: obj.measure_unit,
                        nextAlertWhen: obj.next_alert_when,
                        remark: obj.remark
                    });
                    this.setState({
                        totalPage: data.RESULT_TOTAL,
                        currentPageSize: currentPageSize,
                        searchStr
                    })
                });
                this.setMaintenanceList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getActiveDeviceUserRelated = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getActiveDeviceUserRelated/1000', {
            method: 'post',
            headers: {
                // "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                console.log('data userRelate:', data);
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        deviceId: obj.device_id,
                        deviceNo: obj.device_no
                    });
                });
                this.setDeviceList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setMaintenanceList = (objList) => {
        this.setState({ maintenanceSummaryList: objList });
        console.log('KKKK:', this.state.maintenanceSummaryList);
    }

    setDeviceList = (objList) => {
        this.setState({ deviceNoList: objList });
    }

    resetMaAlertByDeviceId = (deviceId, maListId) => {
        const { t, user_id, user_name, token } = this.props;
        const { currentPage, totalPage, currentPageSize, isGroupOrder } = this.state;
        AlertConfirm(t('ยืนยัน Reset การแจ้งเตือนซ่อมบำรุง'), ' ').then(isOk => {
            if(isOk) {
                window.scrollTo(0, 0);
                //http://{server}/resetMAAlert/{device_id}/{ma_list_id}
                fetch(`http://203.150.199.244/api/admin/resetMAAlert/${deviceId}/${maListId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({})
                })
                .then(response => { return checkStatus(response) })
                .then(() => { this.onPageSelect(1, isGroupOrder) })
                .then(() => {
                    this.setState({
                        currentPage,
                        totalPage,
                        currentPageSize
                    })
                  }
                )
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
            }
        });
    }

    handleChange = (selectedDevice) => {
        this.setState({ selectedDevice });
    }

    onClickSearchDeviceNo = (data) => {
        this.setState({ currentPage: 1 });
        this.getMaintenanceAlertList(data.label);
    }

    onClickEditDeviceNo = (data) => {
        const { t, onClickAddAlertMA } = this.props;
        // console.log('data:', data);
        if(data.value) {
            onClickAddAlertMA(data);
        }else {
            Alert(t('กรุณาเลือกทะเบียนรถก่อนแก้ไข'));
        }
    }

    render(){
        const {
            maintenanceSummaryList,
            deviceNoList,
            selectedDevice,
            isGroupOrder,
            currentPage,
            currentPageSize
        } = this.state;
        const { t, onClickAddAlertMA } = this.props;
        let dataLoop;
        const dataList = map(deviceNoList, (dataEach) => {
            dataLoop = {
                value: dataEach.deviceId,
                label: dataEach.deviceNo
            };
            return dataLoop;
        });
        return(
            <div className="gray-panel" >
                <div className="col-md-8">
                    <h1 className="page-header">
                        <i className="fa fa-wrench" style={{color: '#7386D5'}} />{t('ข้อมูลการซ่อมบำรุง')}
                    </h1>
                </div>
                <div className="row">
                    <div className="col-md-4 row">
                        <div className="col-md-8">
                            <Select
                                value={selectedDevice}
                                onChange={this.handleChange}
                                options={dataList}
                                placeholder={t('ค้นหาเลขทะเบียนรถ')}
                            />
                        </div>
                        <div>
                            <button
                                type="button"
                                className="fas fa-search btn btn-info"
                                style={{ width: '48px', height: '36px' }}
                                onClick={() => this.onClickSearchDeviceNo(selectedDevice)} />
                        </div>
                        <div>
                            <button
                                type="button"
                                className="fas fa-edit btn btn-warning"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t('แก้ไขข้อมูล')}
                                style={{ width: '48px', height: '36px' }}
                                onClick={() => this.onClickEditDeviceNo(selectedDevice)} />
                        </div>
                    </div>
                </div>
                <div className="col-md-1">
                </div>
                <hr/>
                <div className=" mx-auto">
                    <div className="col-md-12 table-responsive">
                       <div>
                            <label>{t('เรียงตามกลุ่ม')}:</label> <input type="checkbox" defaultChecked={isGroupOrder} onChange={(e) => {(this.setState({ isGroupOrder: e.target.checked, currentPage: 1 }), this.onPageSelect(1, e.target.checked))}}/>
                            {/*<label>{'เรียงตามกลุ่ม :'}</label> <input type="checkbox" defaultChecked={isGroupOrder} onChange={(e) => {this.getMaintenanceAlertList('', e.target.checked), this.setState({isGroupOrder: e.target.checked})}}/>*/}
                            <button style={{marginLeft:'85%'}} className="btn btn-info btn-xs" onClick={onClickAddAlertMA} ><span className="fa fa-plus" /></button>
                       </div>
                        <table className="table table-bordred table-striped table-hover " style={{fontSize: '14px'}}>
                            <thead >
                                <tr>
                                    <th rowSpan={2} style={{width:'60px'}}>#</th>
                                    <th rowSpan={2} style={{width:'100px'}}>{t('จัดกลุ่ม')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('อุปกรณ์')}</th>
                                    <th rowSpan={2} >รายการ</th>
                                    <th rowSpan={2} style={{width:'150px'}}>{t('วัดตาม')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('แจ้งทุกๆ')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('ค่าปัจจุบัน')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('เตือนเมื่อถึง')}</th>
                                    <th colSpan={2}>{t('เตือนด้วย')}</th>
                                    <th rowSpan={2} style={{width:'40'}}>{t('ส่งแล้ว')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('เตือนล่าสุด')}</th>
                                    <th rowSpan={2} style={{width:'120px'}}>{t('หมายเหตุ')}</th>
                                    <th rowSpan={2} colSpan={2}>{''}</th>
                                </tr>
                                <tr>
                                    <th style={{width:'50px'}}>Mail</th>
                                    <th style={{width:'50px'}}>Line</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                maintenanceSummaryList.map((data, key) => {
                                    // console.log('data.deviceId:', data.deviceId);
                                    return (
                                        <tr key={key}>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{currentPage > 1 ? ((currentPage - 1) * 10) + key + 1 + (currentPageSize - 10) : key + 1 }</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{data.deviceGroup}</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })} value={data.deviceId}>{data.deviceNo}</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{data.maName}</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })} value={data.measureTypeId}>{data.measureType}</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{data.alertRepeat} {data.measureUnit}</td>
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{data.counter} {data.measureUnit}</td>
                                             {/*measureType: ระยะเวลาที่ใช้*/}
                                            <td onClick={() => this.onClickEditDeviceNo({ value: data.deviceId, label: data.deviceNo })}>{data.nextAlertWhen} {data.measureUnit}</td>

                                            <td style={{color: 'green'}}><i className={data.isEmailAlert ? 'fa fa-lg fa-check-circle' : ''}>{''}</i></td>
                                            <td style={{color: 'green'}}><i className={data.isLineAlert ? 'fa fa-lg fa-check-circle' : ''}>{''}</i></td>
                                            <td style={{color: 'green'}}><i className={data.isAlert ? 'fa fa-lg fa-check-circle' : ''}>{''}</i></td>
                                            <td>{data.lastAlertDtm}</td>
                                            <td>{data.remark}</td>
                                            <td>
                                                {data.isAlert &&
                                                    <i className="btn btn-block btn-xs btn-success"
                                                       onClick={() => this.resetMaAlertByDeviceId(data.deviceId, data.maListId)}>Reset</i>
                                                }
                                                {!data.isAlert &&
                                                    <i style={{height: '43px'}}>{''}</i>
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                            </tbody>
                        </table>
                    </div>
                </div>
                <RCPagination
                    onSelect={this.onPageSelect.bind(this)}
                    onShowSizeChange={this.onPageSizeChange.bind(this)}
                    total={this.state.totalPage}
                    pageSize={this.state.currentPageSize}
                    isGroupOrder={isGroupOrder}
                    currentPage={1}
                    currentPageSize={this.state.currentPageSize}/>
            </div>
        );
    }
}
// MaintenanceSummary.defaultProps = {
//     deviceSelected:{},
//     deviceInfo:{},
// }
//
MaintenanceSummary.propTypes = {
    user_name: PropTypes.string.isRequired,
    // sideBarName: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickAddAlertMA: PropTypes.func.isRequired
}

export default withNamespaces('Menubar')(MaintenanceSummary);



// WEBPACK FOOTER //
// ./src/app/view/components/Maintenance/MaintenanceSummary.js